import commonService from "./common";

const searchDetailService = {
	//todo: add an imsi validator.  15 char length and numeric only

	getSimState(imsi) {
		let param = `IOT_GetSimInfo&imsi=${imsi}`;
		return commonService
			.commonAPI(param)
			.then(response => response.data.message)
			.catch(error => console.error(error));
	},

	// getSimUsage(imsi) {
	//   let param = `IOT_GetSimUsage&imsi=${imsi}`;
	//   return commonService.commonAPI(param)
	//     .then(response => response.data.message)
	//     .catch(error => console.error(error))
	// },

	// getSubscriberStatusByIMSI(imsi) {
	//   let param = `LookupSubscriber&imsi=${imsi}`;
	//   return commonService.commonAPI(param)
	//     .then(response => response.data.message)
	//     .catch(error => console.error(error))
	// },

	getSimDetailPlanAndBalance(msisdn) {
		let param = `getCurrentPlanAndBalance&msisdn=${msisdn}&units=MB`;
		return commonService
			.commonAPI(param)
			.then(response => response.data.message)
			.catch(error => console.error(error));
	},

	getlmeiDataByIMSI(imsi) {
		let param = `IOT_GetImeiData&imsi=${imsi}`;
		return commonService
			.commonAPI(param)
			.then(response => response.data.message)
			.catch(error => console.error(error));
	},

	getCurrentDataSessionByIMSI(imsi) {
		let param = `IOT_GetCurrentSession&imsi=${imsi}`;
		return commonService
			.commonAPI(param)
			.then(response => response.data.message)
			.catch(error => console.error(error));
	},

	getDataVolumeGraphByIMSI(period, imsi) {
		let param = `IOT_GetDataVolumeSummaryByPeriod&period=${period}&imsi=${imsi}`;
		return commonService
			.commonAPI(param)
			.then(response => response.data.message)
			.catch(error => console.error(error));
	},

	getDataVolumeAverageByIMSI(imsi) {
		let param = `IOT_GetAverageDataVolumes&imsi=${imsi}`;
		return commonService
			.commonAPI(param)
			.then(response => response.data.message)
			.catch(error => console.error(error));
	},

	getDataVolumeBillingPeriodByIMSI(imsi) {
		let param = `IOT_GetCurrentUsage&imsi=${imsi}`;
		return commonService
			.commonAPI(param)
			.then(response => response.data.message)
			.catch(error => console.error(error));
	},

	getDataVolumeByRegionByIMSI(period, imsi) {
		let param = `IOT_GetDataVolumeSummaryByRegion_map&period=${period}&imsi=${imsi}`;
		return commonService
			.commonAPI(param)
			.then(response => response.data.message)
			.catch(error => console.error(error));
	},

	getDataManagementAlertsByIMSI(method, imsi) {
		let param = `IOT_Get${method}&imsi=${imsi}`;
		return commonService
			.commonAPI(param)
			.then(response => response.data.message)
			.catch(error => console.error(error));
	},

	getDataManagementMonitorsByIMSI(imsi) {
		let param = `IOT_GetWatchdogs&imsi=${imsi}`;
		return commonService
			.commonAPI(param)
			.then(response => response.data.message)
			.catch(error => console.error(error));
	},

	getDataManagementDataPlansByIMSI(imsi) {
		let param = `IOT_GetDataBucketFullList&filter=${imsi}`;
		return commonService
			.commonAPI(param)
			.then(response => response.data.message)
			.catch(error => console.error(error));
	},
	//
	// getDataBucketList(filter) {
	//   let param = `IOT_GetDataBucketFullList&filter=${filter}`;
	//   return commonService.commonAPI(param)
	//     .then(response => response.data.message)
	//     .catch(error => console.error(error))
	// },

	getWatchDogsLinkedWithDataBucket(dataGroup) {
		let param = `IOT_GetWatchdogsLinkedWithDataBucket&dataGroup=${dataGroup}`;
		return commonService
			.commonAPI(param)
			.then(response => response.data.message)
			.catch(error => console.error(error));
	},

	setLocalDataByIMSI(value, imsi) {
		let param = `SetLocalData&imsi=${imsi}&local_data_only=${value}&user=api_tester`;
		return commonService
			.commonAPI(param)
			.then(response => response.data.message)
			.catch(error => console.error(error));
	},

	getProvideSubscriberInfo(imsi) {
		let param = `IOT_ProvideSubscriberInfo&imsi=${imsi}`;
		return commonService
			.commonAPI(param)
			.then(response => response.data.message)
			.catch(error => console.error(error));
	},

	cancelLocation(imsi, address, action) {
		let param = `IOT_CancelLocation&imsi=${imsi}&description_address=${address}&action=${action}`;
		return commonService
			.commonAPI(param)
			.then(response => response.data.message)
			.catch(error => console.error(error));
	},
};

export default searchDetailService;
